import { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { SocketContext } from '@/contexts/rtm';
import { ServerToClientEvents, SocketEvent } from '@/shared/types/rtm';

export const useRtmTyping = () => {
  const [isTyping, setIsTyping] = useState(false);
  const { socket } = useContext(SocketContext);
  const myTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleStopTyping = useCallback(() => {
    setIsTyping(false);
  }, []);

  const handleMessageCompose: ServerToClientEvents[SocketEvent.messages_compose] = useCallback(
    ({ data }) => {
      if (data.author_type !== 'agent') {
        if (data.action === 'start') {
          setIsTyping(true);

          clearTimeout(myTimeout.current);
          myTimeout.current = setTimeout(handleStopTyping, 5000);
        } else {
          setIsTyping(false);
          clearTimeout(myTimeout.current);
        }
      }
    },
    [handleStopTyping]
  );

  useEffect(() => {
    if (!socket || !socket.connected) {
      return;
    }

    socket?.on(SocketEvent.messages_compose, handleMessageCompose);
    return () => {
      socket?.off(SocketEvent.messages_compose, handleMessageCompose);
    };
  }, [handleMessageCompose, socket]);

  return isTyping;
};
